/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Hero_Cta_WatchInputs */

const en_fw_hero_cta_watch = /** @type {(inputs: Fw_Hero_Cta_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where to watch`)
};

const zh_fw_hero_cta_watch = /** @type {(inputs: Fw_Hero_Cta_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`去哪看`)
};

/**
* | output |
* | --- |
* | "Where to watch" |
*
* @param {Fw_Hero_Cta_WatchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_hero_cta_watch = /** @type {((inputs?: Fw_Hero_Cta_WatchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Hero_Cta_WatchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_hero_cta_watch(inputs)
	return zh_fw_hero_cta_watch(inputs)
});
export { fw_hero_cta_watch as "fw.hero.cta_watch" }